// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__4AOu1","label":"Radio_label__2a0i6","checkMark":"Radio_checkMark__2f1_v","disabled":"Radio_disabled__2R_6Y"};